import React, { useRef, useState } from 'react';
import OrderTrack from './OrderTrack';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';
import TrackOrderModal from '../../TrackOrderModal';
import { editISODate, printToUserTimezone } from '@common/utils/dateUtils';
const isShowTrackOrderButton = (value) => {
    switch (value === null || value === void 0 ? void 0 : value.toLowerCase()) {
        case 'open':
        case 'completed':
        case 'sent':
        case 'partially delivered':
        case 'partially undelivered':
        case 'partially sent':
        case 'ready for pickup':
        case 'shipped':
        case 'delivered':
            return true;
        default:
            return false;
    }
};
const OrdersCard = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    const { t } = useTranslation();
    const [trackingModal, setTrackingModal] = useState(false);
    const { value: orderStatus } = ((_a = props === null || props === void 0 ? void 0 : props.order) === null || _a === void 0 ? void 0 : _a.orderStatus) || { value: '' };
    const giftCardItems = (_b = props.order) === null || _b === void 0 ? void 0 : _b.giftCard;
    const isGiftCardOnly = (giftCardItems === null || giftCardItems === void 0 ? void 0 : giftCardItems.length) && !((_d = (_c = props.order) === null || _c === void 0 ? void 0 : _c.items) === null || _d === void 0 ? void 0 : _d.length);
    const isMultipleGiftCards = (giftCardItems === null || giftCardItems === void 0 ? void 0 : giftCardItems.length) && (giftCardItems === null || giftCardItems === void 0 ? void 0 : giftCardItems.length) > 1;
    const renderItem = (item, index) => {
        var _a, _b, _c, _d, _e, _f;
        const returned = ((_c = (_b = (_a = item.multishippingData) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.displayValue) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'cancelled';
        const stillLifeImage = ((_e = (_d = item.imgs) === null || _d === void 0 ? void 0 : _d.urls) === null || _e === void 0 ? void 0 : _e.find(url => url.includes('_F'))) || ((_f = item.imgs) === null || _f === void 0 ? void 0 : _f.urls[0]);
        return (React.createElement(SwiperSlide, { key: index },
            React.createElement("a", { className: 'text-decoration-none', href: item.productUrl },
                React.createElement("div", { className: 'order-history-container' + (returned ? '-canceled' : '') },
                    React.createElement("img", { src: stillLifeImage, alt: item.productName, className: "img-fluid order-history-img" }),
                    returned && React.createElement("div", { className: "order-history-canceled-label" }, t('orders.canceled'))))));
    };
    /**
     * Renders a carousel with the items of the order
     * @param items Order articles to cycle
     * @param uniqueNumber A unique string used to identify elements associated to the carousel (like the navigation arrow)
     * @returns A carousel of products
     */
    const renderCarousel = (items, uniqueNumber) => {
        var _a, _b;
        const swiperRef = useRef();
        return (React.createElement(React.Fragment, null,
            React.createElement(Swiper, { onSwiper: (swiper) => (swiperRef.current = swiper), keyboard: true, slidesPerView: 1, spaceBetween: 4, threshold: 10, watchSlidesProgress: true, navigation: {
                    nextEl: '.icon--arrow-right-rpy-' + uniqueNumber,
                    prevEl: '.icon--arrow-left-rpy-' + uniqueNumber,
                }, breakpoints: {
                    0: {
                        slidesPerView: 2.3,
                    },
                    375: {
                        slidesPerView: 2.3,
                    },
                    480: {
                        slidesPerView: 2.3,
                    },
                    600: {
                        slidesPerView: 3.2,
                        centerInsufficientSlides: false,
                    },
                    768: {
                        slidesPerView: 5.2,
                        centerInsufficientSlides: true,
                    },
                    1024: {
                        slidesPerView: 3.6,
                        centerInsufficientSlides: false,
                    },
                    1440: {
                        slidesPerView: 4,
                    },
                } }, items === null || items === void 0 ? void 0 : items.map(renderItem)),
            React.createElement("div", { className: classNames('carousel-controls', { 'd-none': ((_b = (_a = props.order) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) <= 3 }) },
                React.createElement("i", { className: 'icon--arrow-left-rpy-' + uniqueNumber }),
                React.createElement("i", { className: 'icon--arrow-right-rpy-' + uniqueNumber }))));
    };
    // Delivery date info for gift cards
    const giftCardDeliveryDateInfo = () => {
        var _a, _b, _c, _d, _e;
        if (giftCardItems === null || giftCardItems === void 0 ? void 0 : giftCardItems.length) {
            const dateValue = isMultipleGiftCards ? null : (_b = (_a = giftCardItems === null || giftCardItems === void 0 ? void 0 : giftCardItems[0]) === null || _a === void 0 ? void 0 : _a.giftCardAttributes) === null || _b === void 0 ? void 0 : _b.sendDate;
            const giftCardSendDate = !!dateValue && printToUserTimezone(dateValue, 'date', 'short');
            const giftCardSendTime = !!dateValue && (printToUserTimezone(dateValue, 'time', 'short')
                + '-'
                + printToUserTimezone(editISODate(dateValue, { minutes: 30 }), 'time', 'short'));
            const deliveryDate = !dateValue ? (_c = props.order) === null || _c === void 0 ? void 0 : _c.creationDate : giftCardSendDate && giftCardSendTime ? t('order.label.gfdeliveryrangedate', { 0: giftCardSendDate, 1: giftCardSendTime }) : giftCardSendDate;
            return isGiftCardOnly ? (React.createElement(React.Fragment, null,
                !isMultipleGiftCards && (React.createElement("div", { className: "left__details__flex" },
                    React.createElement("h6", null,
                        t('order.label.deliveryTo'),
                        ": "),
                    React.createElement("p", { className: "text-center" }, (_e = (_d = giftCardItems === null || giftCardItems === void 0 ? void 0 : giftCardItems[0]) === null || _d === void 0 ? void 0 : _d.giftCardAttributes) === null || _e === void 0 ? void 0 : _e.recipientEmail))),
                React.createElement("div", { className: "left__details__flex" },
                    React.createElement("h6", null,
                        t(giftCardSendTime ? 'order.label.gfdeliverydateandtime' : 'order.deliverydate'),
                        ": "),
                    React.createElement("p", { className: "text-center" }, deliveryDate)))) : (React.createElement("div", { className: "left__details__flex" },
                React.createElement("h6", null,
                    t(giftCardSendTime ? 'order.label.gfdeliverydateandtime' : 'order.label.gfdeliverydate'),
                    ": "),
                React.createElement("p", { className: "text-center" }, deliveryDate)));
        }
        else {
            return null;
        }
    };
    // Delivery date info for regular products
    const deliveryDateInfo = (order) => {
        var _a, _b, _c, _d, _e, _f;
        const deliveryInfo = [];
        if (((_a = order.groupedShipments) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let alreadyHasDeliveryDate = false;
            (_b = order === null || order === void 0 ? void 0 : order.groupedShipments) === null || _b === void 0 ? void 0 : _b.forEach((shipment, i) => {
                if (shipment.status.value === 'cancelled' || shipment.status.value === 'undelivered')
                    return;
                if (shipment.deliveryDate) {
                    deliveryInfo.push({
                        label: t('orders.parcel') + ' ' + (i + 1) + ' ' + t('order.deliverydate'),
                        value: shipment.deliveryDate,
                    });
                }
                else if (order.expectedDeliveryDateFormatted && !alreadyHasDeliveryDate) {
                    alreadyHasDeliveryDate = true;
                    deliveryInfo.push({
                        label: t('orders.parcel') + ' ' + (i + 1) + ' ' + t('order.expecteddelivery'),
                        value: order.expectedDeliveryDateFormatted,
                    });
                }
                else if (shipment.shipmentDate) {
                    deliveryInfo.push({
                        label: t('orders.parcel') + ' ' + (i + 1) + ' ' + t('orders.shippedon'),
                        value: shipment.shipmentDate,
                    });
                }
            });
        }
        else if (orderStatus === 'cancelled' ||
            orderStatus === 'undelivered') {
            return React.createElement(React.Fragment, null);
        }
        else if (orderStatus.includes('pick') && (order === null || order === void 0 ? void 0 : order.expectedDeliveryDateFormatted)) {
            deliveryInfo.push({
                label: t('order.deliverydate'),
                value: order === null || order === void 0 ? void 0 : order.expectedDeliveryDateFormatted,
            });
        }
        else if ((_d = (_c = order.shiptmentAttributes) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.deliveryDate) {
            deliveryInfo.push({
                label: t('order.deliverydate'),
                value: (_f = (_e = order.shiptmentAttributes) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.deliveryDate,
            });
        }
        else if (order.showDeliveryDate && order.deliveryDT) {
            deliveryInfo.push({
                label: t('order.deliverydate'),
                value: order.deliveryDT,
            });
        }
        else if (order === null || order === void 0 ? void 0 : order.expectedDeliveryDateFormatted) {
            deliveryInfo.push({
                label: t((order === null || order === void 0 ? void 0 : order.showDeliveryDate) ? 'order.deliverydate' : 'order.expecteddelivery'),
                value: order === null || order === void 0 ? void 0 : order.expectedDeliveryDateFormatted,
            });
        }
        return (React.createElement(React.Fragment, null, (deliveryInfo === null || deliveryInfo === void 0 ? void 0 : deliveryInfo.length) > 0 ? (deliveryInfo.map((item, i) => (React.createElement("div", { key: item.label + i, className: "left__details__flex" },
            React.createElement("h6", null,
                item.label,
                ":"),
            React.createElement("p", null, item.value))))) : (React.createElement(React.Fragment, null))));
    };
    return (React.createElement("div", { className: 'col-12 orders-card' },
        React.createElement("div", { className: "col-12 col-md-6-4 mt-10 wrapper__left" },
            React.createElement("h4", null,
                t('order.label.orderN'),
                "\u00A0",
                props.order.orderNumber),
            React.createElement(OrderTrack, { status: orderStatus, isGiftCard: isGiftCardOnly }),
            orderStatus !== 'cancelled' && !(orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.includes('lost')) && !(orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.includes('unable')) && orderStatus !== "undelivered" ? (
            // Delivery to
            React.createElement("div", { className: "left__details" },
                giftCardItems ? giftCardDeliveryDateInfo() : null,
                !isGiftCardOnly && ((_g = (_f = (_e = props === null || props === void 0 ? void 0 : props.order) === null || _e === void 0 ? void 0 : _e.shipping) === null || _f === void 0 ? void 0 : _f[0].shippingAddress) === null || _g === void 0 ? void 0 : _g.formattedShort) ? (React.createElement("div", { className: "left__details__flex wrap-center" },
                    React.createElement("h6", null,
                        t(giftCardItems ? 'order.label.parceldeliveryTo' : 'order.label.deliveryTo'),
                        ": "),
                    ((_l = (_k = (_j = (_h = props === null || props === void 0 ? void 0 : props.order) === null || _h === void 0 ? void 0 : _h.shipping) === null || _j === void 0 ? void 0 : _j[0]) === null || _k === void 0 ? void 0 : _k.selectedShippingMethod) === null || _l === void 0 ? void 0 : _l.storePickupEnabled) ? (React.createElement("p", { className: "capitalize text-center" }, (_o = (_m = props === null || props === void 0 ? void 0 : props.order) === null || _m === void 0 ? void 0 : _m.store) === null || _o === void 0 ? void 0 : _o.name)) : (React.createElement("p", { className: "capitalize text-center" }, (_s = (_r = (_q = (_p = props === null || props === void 0 ? void 0 : props.order) === null || _p === void 0 ? void 0 : _p.shipping) === null || _q === void 0 ? void 0 : _q[0]) === null || _r === void 0 ? void 0 : _r.shippingAddress) === null || _s === void 0 ? void 0 : _s.formattedShort)))) : null,
                !isGiftCardOnly && deliveryDateInfo(props.order))) : null,
            React.createElement("div", { className: `col-12 col-sm-6 col-xl-4 ${orderStatus !== 'cancelled' ? 'btn-group' : 'btn-group--no-margin'} ` },
                !isGiftCardOnly && isShowTrackOrderButton(orderStatus) ? (((_u = (_t = props.order) === null || _t === void 0 ? void 0 : _t.groupedShipments) === null || _u === void 0 ? void 0 : _u.length) > 1 ? (React.createElement("button", { className: "button button--secondary", onClick: () => setTrackingModal(true) }, t('orders.trackorder'))) : (React.createElement("a", { href: props.order.trackingUrl || ((_x = (_w = (_v = props.order) === null || _v === void 0 ? void 0 : _v.shipping) === null || _w === void 0 ? void 0 : _w[0]) === null || _x === void 0 ? void 0 : _x.trackingURL) || '', target: "_blank", className: "button button--secondary" }, t('orders.trackorder')))) : null,
                React.createElement("a", { href: `${window.location.href.split('/account/')[0]}/account/order/?orderId=${props.order.orderNumber}`, className: "button button--tertiary" },
                    t('order.show.details'),
                    " ",
                    React.createElement("span", { className: "icon--chevron-small-right" })))),
        orderStatus === 'cancelled' || (orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.includes('lost')) || (orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.includes('unable')) || orderStatus === 'undelivered' ? (React.createElement("div", { className: "col-12 col-md-4-6 wrapper__right order-returns-card__secondary" },
            React.createElement("h4", { className: "title text-center" }, t(orderStatus === 'cancelled' ? 'highlights.ordercancelled.title' : (orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.includes('lost')) ? 'highlights.orderlost.title' : 'highlights.undelivered.title')),
            React.createElement("p", { className: "text-center info-text", dangerouslySetInnerHTML: {
                    __html: t(orderStatus === 'cancelled' ? 'highlights.ordercancelled.text' : (orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.includes('lost')) ? 'highlights.orderlost.text' : 'highlights.undelivered.text', { contactUs: props.cService }),
                } }))) : (React.createElement("div", { className: "col-12 col-md-4-6 wrapper__right carousel hide-mobile" },
            React.createElement("h4", null, t('highlights.orderprodqty')),
            React.createElement("p", null,
                ((_z = (_y = props === null || props === void 0 ? void 0 : props.order) === null || _y === void 0 ? void 0 : _y.orderHistoryItems) === null || _z === void 0 ? void 0 : _z.length) || giftCardItems ? ((giftCardItems === null || giftCardItems === void 0 ? void 0 : giftCardItems.length) || 0) + (((_1 = (_0 = props === null || props === void 0 ? void 0 : props.order) === null || _0 === void 0 ? void 0 : _0.items) === null || _1 === void 0 ? void 0 : _1.length) || 0) : (_3 = (_2 = props === null || props === void 0 ? void 0 : props.order) === null || _2 === void 0 ? void 0 : _2.items) === null || _3 === void 0 ? void 0 : _3.length,
                " ",
                t('label.items')),
            React.createElement("div", { className: "col-12 order-history-section-map", style: { minWidth: 0 } }, renderCarousel((_4 = props === null || props === void 0 ? void 0 : props.order) === null || _4 === void 0 ? void 0 : _4.orderHistoryItems, (_5 = props === null || props === void 0 ? void 0 : props.order) === null || _5 === void 0 ? void 0 : _5.orderNumber)))),
        props.order.multipleShipments ? React.createElement(TrackOrderModal, { isOpen: trackingModal, closeModal: () => setTrackingModal(false), order: props.order }) : null));
};
export default OrdersCard;
